








import { Component, Vue, Watch } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import InfoBar from '@/components/common/InfoBar.vue';
import Menu from '@/components/common/Menu.vue';
import DedicatedMachinesListOperations from '@/components/dedicated-machines-list/DedicatedMachinesListOperations.vue';

export default {
  name: 'DedicatedMachinesList',
  components: {
    Header,
    InfoBar,
    DedicatedMachinesListOperations,
  },
};
